import React from "react";
import { Grid, MenuItem, Button, Typography, Box, FormControlLabel, Switch, makeStyles } from '@material-ui/core';
import { useForm } from "../../../../hooks/useForm";
import { SelectValidator, TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { GASTOS_NOMENCLADOR } from "../../../../utils/constants";
import moment from 'moment'
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { startAlerta } from "../../../../actions/ui/alertas";
import { useEffect } from "react";
import { fetchCuentasNomenclador } from "../../../../actions/nomencladoresActions";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";

const useStyles = makeStyles({
  switchBase:{
    color: '#bdbdbd',
    '&$checked': {
        transform: 'translateX(16px)',
        color: '#4CAF50',
        '& + $track': {
          backgroundColor: '#3E8040',
          opacity: 1,
          border: 'none',
        },
      },
  },  
  TypographyRoot:{
    marginLeft: 20,
    marginRight: 10,
    color: '#757575'
  },
  checked:{},
  track: {},
});

export const FormNomenclador = ({ formData, editable, handleSubmit, handleCancel }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const {
    planes,
  } = useSelector((state) => state.contratacionesCartilla);

  const datosNuevaPractica = {
    anestesista: "",
    ayudante: "",
    topeCantidad: "",
    cantidadAyudante: "",
    codNom: "",
    desNom: "",
    especialista: "",
    gastoQuirurgico: "",
    gastos: "",
    honorarios: "",
    nivel: "",
    nivelComp: "",
    nivelautorizacion: "",
    topeLapso: "",
    valorAnestesista: "",
    valorAyudante: "",
    valorEspecialista: "",
    valorGastos: "",
    valorHonorarios: "",
    valorQuirurgico: "",
    fecBaja: "",
    planesContratos: [],
    nivelCM: "",
    topeCM: "",
    cantAnualCM: "",
    recuperoSur: false,
    realizacionIndividual: false,
  }

  const [
    formValues,
    handleInputChange,
    ,
    setearValor
  ] = useForm(formData !== null ? formData : datosNuevaPractica);

  const onChangePlanesHandler = (e) => {
    setearValor(
      "planesContratos",
      e.map((e) => e.value)
    );
  };

  const onSubmit = (e) => {
    e.preventDefault()
    if (editable) {
      if(formValues.codNom.length !== 8 || formValues.codNom.split(".").length !== 3){
        dispatch(startAlerta("Debe tener 6 numeros separados por un punto cada 2", "error"))
      }else{
            handleSubmit({ ...formValues })
      }
    }
  }

  const handleChangeCheckbox = (e) => {
    setearValor(e.target.name, e.target.checked);
  };

  useEffect(() => {
    dispatch(fetchCuentasNomenclador(formValues.codNom.replace(/\./g, "")))
  }, [dispatch])

  return (
    <ValidatorForm onSubmit={onSubmit}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TextValidator
            margin='normal'
            fullWidth
            label="Código"
            autoComplete="off"
            name="codNom"
            value={formValues.codNom}
            onChange={handleInputChange}
            validators={["required", 'minStringLength:8', 'maxStringLength:8']}
            errorMessages={["El codigo es requerido", "Deben ser 6 numeros separados cada 2 por puntos", "Deben ser 6 numeros separados cada 2 por puntos"]}
            variant="outlined"
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextValidator
            margin='normal'
            fullWidth
            label="Descripción"
            autoComplete="off"
            name="desNom"
            value={formValues.desNom}
            onChange={handleInputChange}
            validators={["required"]}
            errorMessages={["La descripcion es requerida"]}
            variant="outlined"
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="button">Planes</Typography>
          <Select
            onChange={onChangePlanesHandler}
            value={
              formValues.planesContratos?.map((item) => {
                const plan = planes.find((e) => e.id === item);
                return plan
                  ? {
                    value: plan.id,
                    label: plan.descripcion,
                  }
                  : undefined;
              }) ?? []
            }
            isMulti
            name="colors"
            options={planes.map((plan) => ({
              value: plan.id,
              label: plan.descripcion,
            }))}
            placeholder="Seleccione Planes..."
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            menuPosition="fixed"
          />
        </Grid>
        <Grid item xs={6}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="Galeno Honorarios"
            autoComplete="off"
            name="honorarios"
            value={formValues.honorarios}
            onChange={handleInputChange}
            validators={["required", "isFloat"]}
            errorMessages={["El galeno honorario es requerido", "Solo numeros"]}
            type='number'
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={6}>
          <SelectValidator
            variant="outlined"
            fullWidth
            margin="normal"
            label="Valor Honorarios"
            name="valorHonorarios"
            value={formValues.valorHonorarios}
            onChange={handleInputChange}
            validators={["required"]}
            errorMessages={["El valor honorarios es requerido"]}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          >
            <MenuItem value={""}><em>Seleccione...</em></MenuItem>
            {GASTOS_NOMENCLADOR.map((e) => <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>)}
          </SelectValidator>
        </Grid>
        <Grid item xs={6}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="Galeno Gastos"
            autoComplete="off"
            name="gastos"
            value={formValues.gastos}
            onChange={handleInputChange}
            validators={["required", "isFloat"]}
            errorMessages={["El galeno gastos es requerido", "Solo numeros"]}
            type='number'
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={6}>
          <SelectValidator
            variant="outlined"
            fullWidth
            margin="normal"
            label="Valor Gastos"
            name="valorGastos"
            value={formValues.valorGastos}
            onChange={handleInputChange}
            validators={["required"]}
            errorMessages={["El valor gastos es requerido"]}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          >
            <MenuItem value={""}><em>Seleccione...</em></MenuItem>
            {GASTOS_NOMENCLADOR.map((e) => <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>)}
          </SelectValidator>
        </Grid>
        <Grid item xs={6}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="Especialista"
            autoComplete="off"
            name="especialista"
            value={formValues.especialista}
            onChange={handleInputChange}
            validators={["isFloat"]}
            errorMessages={["Solo numeros"]}
            type='number'
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={6}>
          <SelectValidator
            variant="outlined"
            fullWidth
            margin="normal"
            label="Valor Especialista"
            name="valorEspecialista"
            value={formValues.valorEspecialista}
            onChange={handleInputChange}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          >
            <MenuItem value={""}><em>Seleccione...</em></MenuItem>
            {GASTOS_NOMENCLADOR.map((e) => <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>)}
          </SelectValidator>
        </Grid>
        <Grid item xs={4}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="Ayudantes"
            autoComplete="off"
            name="ayudantes"
            value={formValues.ayudantes}
            onChange={handleInputChange}
            validators={["isFloat"]}
            errorMessages={["Solo numeros"]}
            type='number'
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="Cantidad ayudantes"
            autoComplete="off"
            name="cantidadAyudante"
            value={formValues.cantidadAyudante}
            onChange={handleInputChange}
            validators={["isNumber"]}
            errorMessages={["Solo numeros"]}
            type='number'
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={4}>
          <SelectValidator
            variant="outlined"
            fullWidth
            margin="normal"
            label="Valor Ayudante"
            name="valorAyudante"
            value={formValues.valorAyudante}
            onChange={handleInputChange}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          >
            <MenuItem value={""}><em>Seleccione...</em></MenuItem>
            {GASTOS_NOMENCLADOR.map((e) => <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>)}
          </SelectValidator>
        </Grid>
        <Grid item xs={6}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="Anestesista"
            autoComplete="off"
            name="anestesista"
            value={formValues.anestesista}
            onChange={handleInputChange}
            validators={["isFloat"]}
            errorMessages={["Solo numeros"]}
            type='number'
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={6}>
          <SelectValidator
            variant="outlined"
            fullWidth
            margin="normal"
            label="Valor Anestesista"
            name="valorAnestesista"
            value={formValues.valorAnestesista}
            onChange={handleInputChange}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          >
            <MenuItem value={""}><em>Seleccione...</em></MenuItem>
            {GASTOS_NOMENCLADOR.map((e) => <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>)}
          </SelectValidator>
        </Grid>
        <Grid item xs={6}>
          <TextValidator
            margin='normal'
            variant="outlined"
            fullWidth
            label="Gasto Quirurgico"
            autoComplete="off"
            name="gastoQuirurgico"
            value={formValues.gastoQuirurgico}
            onChange={handleInputChange}
            validators={["isFloat"]}
            errorMessages={["Solo numeros"]}
            type='number'
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={6}>
          <SelectValidator
            variant="outlined"
            fullWidth
            margin="normal"
            label="Valor GastoQuirurgico"
            name="valorQuirurgico"
            value={formValues.valorQuirurgico}
            onChange={handleInputChange}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          >
            <MenuItem value={""}><em>Seleccione...</em></MenuItem>
            {GASTOS_NOMENCLADOR.map((e) => <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>)}
          </SelectValidator>
        </Grid>
        <Grid item xs={4}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="NBU (nivel)"
            autoComplete="off"
            name="nivel"
            value={formValues.nivel}
            onChange={handleInputChange}
            validators={["isFloat"]}
            errorMessages={["Solo numeros"]}
            type='number'
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={4}>
          <SelectValidator
            variant="outlined"
            fullWidth
            margin="normal"
            label="Nivel Autorización"
            name="nivelautorizacion"
            value={formValues.nivelautorizacion}
            onChange={handleInputChange}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          >
            <MenuItem value={""}><em>Seleccione...</em></MenuItem>
            <MenuItem value={0}>Cero</MenuItem>
            <MenuItem value={1}>Uno</MenuItem>
            <MenuItem value={2}>Dos</MenuItem>
            <MenuItem value={3}>Tres</MenuItem>
          </SelectValidator>
        </Grid>
        <Grid item xs={4}>
          <SelectValidator
            variant="outlined"
            fullWidth
            margin="normal"
            label="Complejidad"
            name="nivelComp"
            value={formValues.nivelComp}
            onChange={handleInputChange}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          >
            <MenuItem value={""}><em>Seleccione...</em></MenuItem>
            <MenuItem value={"BAJA"}>BAJA</MenuItem>
            <MenuItem value={"MEDI"}>MEDIA</MenuItem>
            <MenuItem value={"ALTA"}>ALTA</MenuItem>
          </SelectValidator>
        </Grid>
        <Grid item xs={6}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="Tope cantidad"
            autoComplete="off"
            name="topeCantidad"
            value={formValues.topeCantidad}
            onChange={handleInputChange}
            validators={["isNumber"]}
            errorMessages={["Solo numeros"]}
            type='number'
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="Tope Lapso (Dias)"
            autoComplete="off"
            name="topeLapso"
            value={formValues.topeLapso}
            onChange={handleInputChange}
            validators={["isNumber"]}
            errorMessages={["Solo numeros"]}
            type='number'
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={3}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="Nivel CM"
            autoComplete="off"
            name="nivelCM"
            value={formValues.nivelCM}
            onChange={handleInputChange}
            validators={["isNumber"]}
            errorMessages={["Solo numeros"]}
            type='number'
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={3}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="Tope CM"
            autoComplete="off"
            name="topeCM"
            value={formValues.topeCM}
            onChange={handleInputChange}
            validators={["isNumber"]}
            errorMessages={["Solo numeros"]}
            type='number'
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        <Grid item xs={3}>
          <TextValidator
            variant="outlined"
            margin='normal'
            fullWidth
            label="Cantidad anual CM"
            autoComplete="off"
            name="cantAnualCM"
            value={formValues.cantAnualCM}
            onChange={handleInputChange}
            validators={["isNumber"]}
            errorMessages={["Solo numeros"]}
            type='number'
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </Grid>
        
        <Grid item xs={3}>
          <Box display='flex' justifyContent='left' alignItems='center' >
            <Grid item xs={9} /* md={3} */ >
              <Typography className={classes.TypographyRoot}>SURGE</Typography>
            </Grid>
            <FormControlLabel 
              control={
                <Switch 
                  name="recuperoSur"
                  checked={formValues.recuperoSur}
                  onChange={handleChangeCheckbox}
                  color="primary"
                  classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                />}
              // label="Recupero Sur"
              // labelPlacement="Start"
            />
          </Box>
          
          <Box display='flex' justifyContent='left' alignItems='center'>
            <Grid item xs={9} /* md={3} */ >
              <Typography className={classes.TypographyRoot}>Realización Individual</Typography>
            </Grid>
            <FormControlLabel 
              control={
                <Switch 
                  name="realizacionIndividual"
                  checked={formValues.realizacionIndividual}
                  onChange={handleChangeCheckbox}
                  color="primary"
                  classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                />}
            />
          </Box>
        </Grid>
        
        {
          formValues.id &&
          <>
            {/* 
              <Grid item xs={6}>
                <TextValidator
                  margin='normal'
                  fullWidth
                  label="Valor coseguro"
                  autoComplete="off"
                  disabled
                  defaultValue={formValues.valorCoseguro}
                />
              </Grid> 
            */}
            <Grid item xs={6}>
              <TextValidator
                variant="outlined"
                margin='normal'
                fullWidth
                label="Nomenclada"
                autoComplete="off"
                disabled
                defaultValue={formValues.nomenclada}
                InputLabelProps={{ style: { fontWeight: 'bold' } }}
              />
            </Grid>
            <Grid item xs={6}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="dialogFecBaja"
                  label="Fecha de Baja"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  maxDate={moment()}
                  value={
                    moment(formValues.fecBaja).isValid()
                      ? moment(formValues.fecBaja)
                      : null
                  }
                  onChange={(date) => {
                    setearValor("fecBaja", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </>
        }
      </Grid>
      <Grid container spacing={2} justify="flex-end">
        <Grid item>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            startIcon={<CancelIcon />}
            onClick={handleCancel}
          >
            CANCELAR
          </Button>
        </Grid>
        {
          (editable) &&

          <Grid item>
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<SaveIcon />}
              type='submit'
            >
              GUARDAR
            </Button>
          </Grid>
        }
      </Grid>
    </ValidatorForm>
  );
};
